'use client';

import { clearInstantRouteTransition } from '@/lib/instantRouteNavStore';
import { useEffect } from 'react';

/** Clears the instant-nav overlay once the bolge listing page has mounted. */
export default function BolgeNavSettled() {
  useEffect(() => {
    clearInstantRouteTransition();
  }, []);

  return null;
}
